var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55556 2C2.24873 2 2 2.24873 2 2.55556V4.66667H14V2.55556C14 2.24873 13.7513 2 13.4444 2H2.55556ZM16 2.55556C16 1.14416 14.8558 0 13.4444 0H2.55556C1.14416 0 0 1.14416 0 2.55556V13.4444C0 14.8558 1.14416 16 2.55556 16H13.4444C14.8558 16 16 14.8558 16 13.4444V2.55556ZM14 6.66667H6.66667V14H13.4444C13.7513 14 14 13.7513 14 13.4444V6.66667ZM4.66667 14V6.66667H2V13.4444C2 13.7513 2.24873 14 2.55556 14H4.66667Z",
    fill: "#8B97F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCardIcon);
export default __webpack_public_path__ + "static/media/addCardIcon.0ad1a2f6e3f26060b02c8d35e2de26dd.svg";
export { ForwardRef as ReactComponent };